// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3a86adfa","80":"d2c173c1","115":"5f04efc8","277":"49ed7af3","352":"b0ecc523","431":"d9c0382c","496":"d73de973","761":"d8b9d384","971":"ccd17fc6","977":"5c86788c"}[chunkId] + ".chunk.js";
};